import React from 'react';
import { Button } from '@mui/material';

/**
 * Componente que exibe os botões de ação
 * 
 * @param {object} props - Propriedades do componente
 * @param {function} props.onContinue - Função para continuar
 * @param {function} props.onReturn - Função para retornar
 * @param {function} props.t - Função de tradução
 */
const ActionButtons = ({ onContinue, onReturn, t }) => {
  return (
    <>
      <Button
        data-testid="actionButtons_continueShopping_btn"
        variant="contained"
        onClick={onContinue}
        sx={{
          fontSize: "16.083px",
          fontWeight: 600,
          textTransform: "uppercase",
          backgroundColor: "#662d91",
          color: "#fff",
          width: "100%",
          height: "44px",
          borderRadius: "6px",
          "&:hover": {
            backgroundColor: "#5a2480",
          },
        }}
      >
        {t("purchase.continue_shopping")}
      </Button>
      
      <Button
        data-testid="actionButtons_return_btn"
        variant="outlined"
        onClick={onReturn}
        sx={{
          fontSize: "16.083px",
          fontWeight: 700,
          textTransform: "uppercase",
          backgroundColor: "#fff",
          color: "#662d91",
          border: "1px solid #662d91",
          width: "100%",
          height: "44px",
          borderRadius: "6px",
        //   marginTop: "10px",
          "&:hover": {
            backgroundColor: "#f9f4fc",
          },
        }}
      >
        {t("purchase.return")}
      </Button>
    </>
  );
};

export default React.memo(ActionButtons);